import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-site-switcher',
  templateUrl: './site-switcher.component.html',
  styleUrls: ['./site-switcher.component.scss']
})
export class SiteSwitcherComponent implements OnInit {
  facilityName: string = '';
  facilityData:Array<any> =[]
  constructor(public dialogRef: MatDialogRef<SiteSwitcherComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  onCloseDialog(){
    this.dialogRef.close({ event: 'cancelConsern' });
  }
  redirectSelectedfacility(facility){
    this.dialogRef.close({ event: 'facilitySelected',data:facility });
  }
  removeSearchText() {
    this.facilityName = '';
  }
}
